module.exports = __webpack_public_path__ + "static/media/Kaudulla.d7860109.png";